
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import { getAttributeById } from '../../common/common/iskn/dataDefinition';
import { DEFINITION_OPSUB } from '../../common/common/iskn/opsub';

import FilterBase from './FilterBase';
import FilterItemText from './FilterItemText';
import FilterItemValues from './FilterItemValues';

const FilterContent = () => {

    return (
        <FilterBase
            objectType={DEFINITION_OPSUB.objectType}
            items={[
                <FilterItemText definition={getAttributeById(DEFINITION_OPSUB, 'name')} />,
                <FilterItemText definition={getAttributeById(DEFINITION_OPSUB, 'address')} />,
                <FilterItemValues definition={getAttributeById(DEFINITION_OPSUB, 'opsub_type')} />
            ]}
        />
    );
}

const OpsubFilter = () => {
    return (
        <Stack>
            <FilterContent />
        </Stack>
    );
}

export default OpsubFilter;
